// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-L_G","productName":"Table_productName__2cwpP"};